"use strict";

// Копировалка ссылки на объект подсказки

import { copy } from "../copy";

export default {
    // Строит ссылку на выбранный объект подсказок
    buildUrl: function (resource, id) {
        var location = document.location;
        return location.protocol + "//" + location.host + "/find/" + resource + "/" + id + "/";
    },

    // Копирует ссылку в буфер обмена
    copy: function (url) {
        copy(url);
    },

    // Показывает галочку «скопировано» при нажатии на ссылку
    showCopied: function (self) {
        self.copied = true;
        setTimeout(function () {
            self.copied = false;
        }, 1000);
    },
};
